import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-inline-flex align-center justify-space-between",
  style: {"gap":"5px"}
}
const _hoisted_2 = { class: "d-flex justify-space-between w-100 ms-3 items-center" }
const _hoisted_3 = {
  class: "d-flex align-center",
  style: {"gap":"10px"}
}
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "mb-7" }
const _hoisted_6 = { class: "mb-7" }
const _hoisted_7 = { class: "mb-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["MoleculeTitleSetings"], {
      addBtn: $setup.addNew,
      title: $setup.type == 'C' ? 'Cadastro de provedor': $setup.type == 'E' ? 'Editando provedor' : 'Provedor',
      onHandleConfirm: $setup.replacement
    }, null, 8 /* PROPS */, ["addBtn", "title"]),
    _createCommentVNode(" <AtomTitle title=\"Provedor\" /> "),
    (!$setup.addNew)
      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode($setup["MoleculeTable"], {
                  onChangePerPage: _cache[1] || (_cache[1] = (ev) => ($setup.perPage = ev)),
                  onChangePage: _cache[2] || (_cache[2] = (ev) => ($setup.page = ev)),
                  filters: "",
                  headers: $setup.headers,
                  items: $setup.items,
                  totalItems: $setup.totalItems,
                  perPage: $setup.perPage,
                  page: $setup.page,
                  onBlur: $setup.searching,
                  onHandleSort: $setup.sort,
                  onItemClick: _cache[3] || (_cache[3] = ($event: any) => {$setup.handleEdit($event, true); }),
                  onItemClickDelete: _cache[4] || (_cache[4] = ($event: any) => ($setup.handleDelete($event)))
                }, {
                  actions: _withCtx(({ props }) => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode($setup["AtomButton"], {
                        background: "white",
                        radius: "",
                        class: "pa-0",
                        onClick: _withModifiers(($event: any) => ($setup.handleEdit(props.row)), ["stop"])
                      }, {
                        default: _withCtx(() => [
                          _createVNode($setup["EditSquareIcon"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                      (props.row.archived == 0)
                        ? (_openBlock(), _createBlock($setup["AtomButton"], {
                            key: 0,
                            background: "white",
                            radius: "",
                            class: "pa-0",
                            onClick: _withModifiers(($event: any) => ($setup.handleDelete(props.row)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode($setup["DeleteIcon"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]),
                  areaFilter: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                        _createCommentVNode(" <AtomButton background=\"white\" text=\"Manusear colunas\" outlined> </AtomButton> ")
                      ], -1 /* HOISTED */)),
                      _createElementVNode("div", _hoisted_3, [
                        _createCommentVNode(" <AtomButton background=\"white\" outlined>\n                <PaperUploadIcon />\n              </AtomButton>\n              <AtomButton background=\"white\" text=\"Excel\" outlined> </AtomButton>\n              <AtomButton prependIcon appendIcon background=\"white\" outlined text=\"Importar/Exportar\">\n                <template #appendIcon>\n                  <ArrowDown3Icon />\n                </template>\n              </AtomButton> "),
                        _createVNode($setup["AtomButton"], {
                          class: "ms-2",
                          text: "Novo Provedor",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => {
                  $setup.clear();
                  $setup.showModalUpload = true;
                })
                        })
                      ])
                    ])
                  ]),
                  "content-action": _withCtx(({ props }) => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["AtomButton"], {
                              center: "text-center",
                              onClick: _withModifiers(($event: any) => ($setup.handleEdit(props, true)), ["stop"]),
                              class: "mx-auto w-100 rounded-pill",
                              text: 'Editar'
                            }, null, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode($setup["AtomButton"], {
                              center: "text-center",
                              onClick: _withModifiers(($event: any) => ($setup.handleDelete(props)), ["stop"]),
                              class: "mx-auto w-100 rounded-pill",
                              text: "Excluir",
                              background: "gray-05"
                            }, null, 8 /* PROPS */, ["onClick"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["headers", "items", "totalItems", "perPage", "page"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    ($setup.addNew)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { class: "my-3" }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", { class: "text-gray-02" }, "Preencha todos os campos corretamente para cadastrar um novo provedor.")
                    ], -1 /* HOISTED */)
                  ])),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomInput"], {
                      width: "100%",
                      required: "",
                      msgError: "Campo obrigatório",
                      hasError: !$setup.data.nome,
                      label: "Nome",
                      placeholder: "Digite aqui...",
                      modelValue: $setup.data.nome,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.nome) = $event))
                    }, null, 8 /* PROPS */, ["hasError", "modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomInput"], {
                      width: "100%",
                      mask: '##.###.###/####-##',
                      required: "",
                      msgError: "Campo obrigatório",
                      hasError: !$setup.data.provedorCnpj,
                      label: "CNPJ",
                      placeholder: "Digite aqui...",
                      modelValue: $setup.data.provedorCnpj,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.provedorCnpj) = $event))
                    }, null, 8 /* PROPS */, ["hasError", "modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomInput"], {
                      width: "100%",
                      mask: '(##) #####-####',
                      required: "",
                      msgError: "Campo obrigatório",
                      hasError: !$setup.data.provedorTelefone,
                      label: "Telefone",
                      placeholder: "Digite aqui...",
                      modelValue: $setup.data.provedorTelefone,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.provedorTelefone) = $event))
                    }, null, 8 /* PROPS */, ["hasError", "modelValue"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_row, { class: "mt-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomButton"], {
                      center: "text-center",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.handleAddOrUpdate())),
                      class: "mx-auto w-100 rounded-pill",
                      text: $setup.type == 'C' ? 'Concluir Cadastro': 'Concluir edição'
                    }, null, 8 /* PROPS */, ["text"])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["AtomButton"], {
                      center: "text-center",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.addNew = false, $setup.type = '', $setup.data = {} )),
                      class: "mx-auto w-100 rounded-pill",
                      text: "Voltar",
                      background: "gray-05"
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["MoleculeModal"], {
      onHandleConfirm: $setup.handleAddOrUpdate,
      onHandleCancel: _cache[13] || (_cache[13] = ($event: any) => ($setup.showModalUpload = false)),
      title: "Novo provedor",
      subtitle: 'Preencha todos os campos corretamente para cadastrar um novo provedor',
      show: $setup.showModalUpload,
      "btn-close-text": "Cancelar",
      "btn-confirm-text": "Registrar"
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["AtomInput"], {
              width: "100%",
              required: "",
              msgError: "Campo obrigatório",
              hasError: !$setup.data.nome,
              placeholder: "Nome",
              label: "Nome",
              modelValue: $setup.data.nome,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.data.nome) = $event))
            }, null, 8 /* PROPS */, ["hasError", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode($setup["AtomInput"], {
              width: "100%",
              mask: '##.###.###/####-##',
              required: "",
              msgError: "Campo obrigatório",
              hasError: !$setup.data.provedorCnpj,
              placeholder: "CNPJ",
              label: "CNPJ",
              modelValue: $setup.data.provedorCnpj,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.data.provedorCnpj) = $event))
            }, null, 8 /* PROPS */, ["hasError", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["AtomInput"], {
              width: "100%",
              mask: '(##) #####-####',
              required: "",
              msgError: "Campo obrigatório",
              hasError: !$setup.data.provedorTelefone,
              placeholder: "Telefone",
              label: "Telefone",
              modelValue: $setup.data.provedorTelefone,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.data.provedorTelefone) = $event))
            }, null, 8 /* PROPS */, ["hasError", "modelValue"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}